
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.998 12.83l-4.862 4.548c-2.337 2.185-6.063 2.16-8.367-.058a5.663 5.663 0 01.02-8.242l7.284-6.948c1.59-1.517 4.154-1.505 5.729.025l.024.025a3.882 3.882 0 01-.04 5.6l-7.341 7.068a2.167 2.167 0 01-2.825.135l-.12-.096a1.775 1.775 0 01-.156-2.68l4.937-4.87","stroke":"#9B9B9B","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    